var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 27H15V31H9V27ZM19 31H25V27H19V31ZM9 39H15V35H9V39ZM19 39H25V35H19V39ZM9 15H15V11H9V15ZM19 15H25V11H19V15ZM9 23H15V19H9V23ZM19 23H25V19H19V23ZM49 17V49H1V7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1L27 1C28.5913 1 30.1174 1.63214 31.2426 2.75736C32.3679 3.88258 33 5.4087 33 7V11H43C44.5913 11 46.1174 11.6321 47.2426 12.7574C48.3679 13.8826 49 15.4087 49 17ZM29 7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V45H29V7ZM45 17C45 16.4696 44.7893 15.9609 44.4142 15.5858C44.0391 15.2107 43.5304 15 43 15H33V45H45V17ZM37 31H41V27H37V31ZM37 39H41V35H37V39ZM37 23H41V19H37V23Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinVerification);
export default __webpack_public_path__ + "static/media/cin_verification.9bbcdc8d1e03b8716077662283286fb1.svg";
export { ForwardRef as ReactComponent };